/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import { useState, useRef, useEffect } from 'react';
import {
  Stack,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  Box,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import fetchDeviceList from '../../utils/fetchDeviceList';
import fetchStreamList from '../../utils/fetchStreamList';
import { appSliceActions } from '../../appSlices/appSlice';
import axiosInstance from '../../utils/axiosInstance';
import Iconify from '../iconify';
import SingleSelector from '../single-selector/singleSelector';

export default function AddSensorManually() {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [deviceType, setDeviceType] = useState('RTSP');
  const [showPassword, setShowPassword] = useState(false);
  const [vstHost, setVstHost] = useState(null);
  const hostList = useSelector((state) => state.app.hostList);
  const sensorList = useSelector((state) => state.app.sensorList);
  const usernameRef = useRef();
  const ipAddressRef = useRef();
  const rtspUrlRef = useRef();
  const nameRef = useRef();
  const locationRef = useRef();
  const passwordRef = useRef();
  const [uniqueRemoteDevices, setUniqueRemoteDevices] = useState([]);
  const [remoteDevice, setRemoteDevice] = useState(null);

  const handleSetRemoteDevice = (dev) => {
    setRemoteDevice(dev);
  };

  useEffect(() => {
    if (hostList && hostList.length === 1) {
      setVstHost(hostList[0]);
    }
  }, [hostList]);

  useEffect(() => {
    // Create a map to store unique remoteDeviceId and their corresponding data
    const uniqueDevicesMap = new Map();
    // Iterate through the JSON data and populate the map
    sensorList.forEach((item) => {
      const deviceId = item.remoteDeviceId;
      if (!uniqueDevicesMap.has(deviceId)) {
        uniqueDevicesMap.set(deviceId, {
          remoteDeviceId: deviceId,
          remoteDeviceLocation: item.remoteDeviceLocation,
          remoteDeviceName: item.remoteDeviceName,
        });
      }
    });
    // Convert the map values into an array of unique objects
    const uniqueDevicesArray = Array.from(uniqueDevicesMap.values());
    setUniqueRemoteDevices(uniqueDevicesArray)
  }, [sensorList]);

  const handleSubmit = () => {
    if (!vstHost) {
      enqueueSnackbar(`Error - ${window.adaptorType} device not selected`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    const jsonData = {
      name: nameRef.current.value,
      location: locationRef.current.value,
      username: usernameRef.current.value,
      password: passwordRef.current.value,
      // remoteDeviceId: remoteDevice ? remoteDevice.remoteDeviceId : ""
    };
    if (deviceType === 'IP') jsonData.sensorIp = ipAddressRef.current.value;
    else jsonData.sensorUrl = rtspUrlRef.current.value;
    enqueueSnackbar(`Pending - add ${deviceType === 'IP' ? jsonData.sensorIp : jsonData.sensorUrl} on ${vstHost}`, {
      variant: 'info',
      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    });
    console.log("sensor add json: ", jsonData);
    axiosInstance
      .post(`${window.location.protocol}//${vstHost}/api/v1/sensor/add`, jsonData)
      .then(async () => {
        enqueueSnackbar(`Success - ${deviceType === 'IP' ? jsonData.sensorIp : jsonData.sensorUrl} added successfully`, {
          variant: 'success',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
        const sensorList = await fetchDeviceList(vstHost);
        if (sensorList != null) {
          for (let i = 0; i < sensorList.length; i += 1) {
            sensorList[i].host = vstHost;
          }
          dispatch(appSliceActions.addDevice(sensorList));
        }
        const streamList = await fetchStreamList(vstHost);
        if (streamList != null) {
          for (let i = 0; i < streamList.length; i += 1) {
            streamList[i].host = vstHost;
          }
          dispatch(appSliceActions.addStream(streamList));
        }
      })
      .catch((error) => {
        if (error.response.data == null) {
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        } else {
          enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        }
      });
  };

  const handleDeviceType = (event) => {
    setDeviceType(event.target.value);
  };

  return (
    <>
      <Stack spacing={3} sx={{ mb: 2 }}>
        <FormControl>
          <RadioGroup name="device-type" value={deviceType} onChange={handleDeviceType}>
            <FormControlLabel
              value="RTSP"
              control={<Radio />}
              label={(
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  RTSP
                </Typography>
              )}
              id="rtsp-sensor"
            />
            <FormControlLabel
              value="IP"
              control={<Radio />}
              label={(
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  IP
                </Typography>
              )}
              id="ip-sensor"
            />
          </RadioGroup>
        </FormControl>
        {
          false &&
          <SingleSelector
            id="select-remote-device"
            placeholder="Type to search"
            label="Select remote device"
            value={remoteDevice}
            onChange={handleSetRemoteDevice}
            getOptionLabel={(option) => {
              if (option.remoteDeviceName && option.remoteDeviceLocation) {
                return `${option.remoteDeviceName} (${option.remoteDeviceLocation}) ${option.remoteDeviceId.substring(0, Math.min(option.remoteDeviceId.length, 18))}`;
              } if (option.remoteDeviceName) {
                return `${option.remoteDeviceName} ${option.remoteDeviceId.substring(0, Math.min(option.remoteDeviceId.length, 18))}`;
              }
              return option.remoteDeviceId;
            }}
            options={uniqueRemoteDevices}
          />
        }
        <TextField
          id="sensor-ip-address"
          name="ip-address"
          label="ip address"
          inputRef={ipAddressRef}
          disabled={deviceType === 'RTSP'}
        />
        <TextField name="rtsp-url" label="rtsp url" inputRef={rtspUrlRef} disabled={deviceType === 'IP'} />
        <TextField name="location" label="location" inputRef={locationRef} />
        <TextField id="sensor-name" name="name" label="name" inputRef={nameRef} />
        <TextField id="sensor-username" name="username" label="username" inputRef={usernameRef} />
        <TextField
          id="sensor-password"
          name="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          inputRef={passwordRef}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <SingleSelector
          id="add-sensor-manually"
          placeholder="Type to search"
          label={`Select ${window.adaptorType} device`}
          value={vstHost}
          onChange={setVstHost}
          getOptionLabel={(option) => `${window.adaptorType} at ${option}`}
          options={hostList}
        />
      </Stack>
      <Box m={1} display="flex" justifyContent="flex-end" alignItems="flex-end">
        <LoadingButton
          id="submit-sensor-manually"
          size="large"
          type="submit"
          variant="contained"
          onClick={handleSubmit}
        >
          Submit
        </LoadingButton>
      </Box>
    </>
  );
}
